import { useQuery } from 'react-query';
import { apiClient } from '../api/client';

export interface UserActivityDataPoint {
  date: string;
  user_id: string;
  count: number;
}

export interface UserActivityResponse {
  days: number;
  definition_updates: UserActivityDataPoint[];
  task_creations: UserActivityDataPoint[];
}

export const useUserActivity = (days: number = 30) => {
  return useQuery<UserActivityResponse>(
    ['userActivity', days],
    async () => {
      const response = await apiClient.get(`/api/v1/scraper/statistics/user-activity?days=${days}`);
      return response.data;
    },
    {
      refetchInterval: 300000,
      staleTime: 120000,
      cacheTime: 600000,
    }
  );
};
